(function () {
  'use strict';
  angular.module('vcutils.vcshare')
    .component('sharenew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="sharenew-component" data-hook="sharenew-component">
        <div class="btn btn-success" ng-click="vm.addShare()" ng-hide="vm.newshare">Neues Netzlaufwerk anlegen</div>
        <div ng-show="vm.newshare">
          <shareform share="vm.newshare" parentsave="vm.saveNewShare(share)" oncancel="vm.cancel()"></shareform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Netzlaufwerk erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Netzlaufwerks wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Netzlaufwerk konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Share', 'Rlog',
        function ($log, Share, Rlog) {
          let vm = this;
          vm.addShare = addShare;
          vm.saveNewShare = saveNewShare;
          vm.cancel = cancel;
          
          function addShare() {
            vm.newshare = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewShare(share) {
            $log.debug('debug: create new share: ', share);
            delete vm.newshare;
            Share.$create(share).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new share failed: ', err);
              Rlog.error('vcutils.share', 'sharenew', 'Creation of new share failed: ', {error: err, share: vm.newshare});
            });
          }
          
          function cancel() {
            delete vm.newshare;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());